import { MessageCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useEffect, useState } from "react";
import { Field } from "@/components/Field";
import { TextArea } from "@/components/Bits";

const waNumber = (cli) => {
  const d = (cli?.whatsapp || cli?.telefone || "").replace(/\D/g, "");
  return d.length === 10 || d.length === 11 ? `55${d}` : d;
};

const buildMsg = (os, previsao) => {
  const nome = os.fazenda?.responsavel || os.cliente?.responsavel || os.cliente?.nome || "";
  return `Olá${nome ? `, ${nome}` : ""}! O técnico ${os.tecnico_nome || "da Fazenda Digital"} está a caminho da ${os.fazenda?.nome || "fazenda"} para o atendimento da ${os.numero}` +
    `${os.categoria_nome ? ` (${os.categoria_nome})` : ""}.${previsao ? ` Previsão de chegada: ${previsao}.` : ""}\nFazenda Digital — Tecnologia Agrícola`;
};

export const DeslocamentoDialog = ({ open, onOpenChange, os }) => {
  const [previsao, setPrevisao] = useState("");
  const [msg, setMsg] = useState("");
  useEffect(() => { if (open) setMsg(buildMsg(os, previsao)); }, [open, os, previsao]);
  const phone = waNumber(os.cliente);
  const send = () => {
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`, "_blank");
    onOpenChange(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-3xl max-h-[92vh] overflow-y-auto" data-testid="deslocamento-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Avisar o cliente</DialogTitle></DialogHeader>
        <p className="-mt-2 text-sm text-[#5C6B66]">Você está em deslocamento. Envie um aviso no WhatsApp {phone ? "do cliente" : "(cliente sem WhatsApp cadastrado — escolha o contato)"}.</p>
        <div className="space-y-4">
          <Field label="Previsão de chegada (opcional)" id="dsl-prev" type="time" value={previsao} onChange={(e) => setPrevisao(e.target.value)} data-testid="deslocamento-previsao" />
          <TextArea label="Mensagem" id="dsl-msg" rows={5} value={msg} onChange={(e) => setMsg(e.target.value)} data-testid="deslocamento-mensagem" />
          <button onClick={send} data-testid="deslocamento-enviar"
            className="h-14 w-full rounded-xl bg-[#25D366] text-white font-semibold flex items-center justify-center gap-2 hover:opacity-90 active:scale-[0.98]">
            <MessageCircle className="h-5 w-5" /> Enviar aviso no WhatsApp
          </button>
          <button onClick={() => onOpenChange(false)} className="h-12 w-full text-[#5C6B66] font-semibold" data-testid="deslocamento-pular">Agora não</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
